<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.inventory.outInInventory')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/inventory/outInInventory">
              <span>{{$t('tlt.outInInventory')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="#">
              <span>{{$t('tlt.inventory.outInInventory')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button class="btn btn-outline-primary" v-on:click="MMFNew('outIn')">
            <i class="fa fa-fw fa-lg fa-plus"></i>
            <span class="text">{{ $t("btn.basic.add") }}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.basic.matCode')}}:</label>
                  <dimsearch
                    v-model="matCodeFilter"
                    :entity="materials"
                    bindId="outInMaterialFilter"
                    bindProp="matCode"
                    submitProp="matCode"
                  ></dimsearch>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.basic.matName')}}:</label>
                  <dimsearch :entity="materials" bindId="outInMaterialFilter" bindProp="matName"></dimsearch>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.inventory.outInClass')}}:</label>
                  <select class="form-control" v-model="outInClassFilter">
                    <option value="out">{{ $t("lbl.inventory.out") }}</option>
                    <option value="in">{{ $t("lbl.inventory.in") }}</option>
                    <option value="ALL">{{ $t("lbl.inventory.all") }}</option>
                  </select>
                </div>
              </form>
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.inventory.invCode')}}</label>
                  <dimsearch
                    v-model="invCodeFilter"
                    :entity="locations"
                    bindId="outInLocationFilter"
                    bindProp="code"
                    submitProp="code"
                  ></dimsearch>
                </div>

                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.inventory.invName')}}：</label>
                  <dimsearch :entity="locations" bindId="outInLocationFilter" bindProp="locName"></dimsearch>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.basic.stDate')}}:</label>
                  <!--input class="form-control" type="date" v-model="stFilter"/-->
                  <date-picker v-model="stFilter" />
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.basic.endDate')}}:</label>
                  <!--input class="form-control" type="date" v-model="etFilter"/-->
                  <date-picker v-model="etFilter" />
                </div>
                <div class="col-lg-4 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="clearFilter()"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('outIn')">
                      <!--button class="btn btn-primary" type="button" v-on:click="saveNew()"-->
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{$t('btn.basic.search')}}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div id="outInResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component">
                <div class="col-lg-12"></div>
              </div>
              <mmf-table
                entity="outIn"
                inline-actions-disabled
                checkboxColumnDisabled
                disableDelete
                disableEdit
              ></mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { gridFields, filterFields } from "@/model/prd/inventoryMgt/OutIn";
import MmfTable from "@/components/MmfTable";
import datePicker from "@/components/MmfDatepicker";
import dimsearch from "@/components/MMFDimSearch";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "outIn/getField",
  mutationType: "outIn/updateField"
});

export default {
  name: "outIn",
  data() {
    return {
      locations: [],
      materials: []
    };
  },
  components: {
    MmfTable,
    datePicker,
    dimsearch
  },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
    ...mapFields(filterFields),
    ...mapState({
      checkedItems: state => state.outIn.checkedItems,
      selectedItem: state => state.outIny.entity
    })
  },
  methods: {
    ...mapActions("base", [
      "MMFselectRow",
      "MMFselectAllRows",
      "MMFNew",
      "MMFEdit",
      "MMFLoadRows",
      "MMFDelete",
      "MMFClearFilter"
    ]),
    actionDisabled() {
      return this.checkedItems.length != 1;
    },
    clearFilter() {
      this.$store.dispatch("dimSearch/initBind", {
        outInLocationFilter: {}
      }),
        this.$store.dispatch("dimSearch/initBind", {
          outInMaterialFilter: {}
        }),
        this.MMFClearFilter("outIn");
    }
  },
  mounted() {
    //   this.MMFLoadRows("outIn");
    this.$store
      .dispatch(
        "api/get",
        {
          url:
            this.$store.state.location.baseModuleUrl + "/location/findByPerId"
        },
        {
          root: true
        }
      )
      .then(data => {
        data.push({});
        this.locations = data;
      }),
      this.$store
        .dispatch(
          "api/get",
          {
            url: this.$store.state.location.baseModuleUrl + "/material/findAll"
          },
          {
            root: true
          }
        )
        .then(data => {
          data.push({});
          this.materials = data;
        });
  }
};
</script>
